<template>
  <div class="combo-container">
    <p>{{ title }}</p>
    <model-list-select
      :id="id"
      v-model="field"
      :option-text="optionLabel"
      class="combo-box"
      :placeholder="placeholder"
      :options="options"
      :disabled="disabled"
      option-value="value"
    >
      <span slot="no-options">{{ notFoundMessage }}</span>
    </model-list-select>
  </div>
</template>

<script>
export default {
  name: 'ComboBox',
  props: {
    title: String,
    options: Array,
    id: String,
    optionLabel: String,
    placeholder: String,
    disabled: {
      type: Boolean,
      default: false
    },
    notFoundMessage: {
      type: String,
      default: 'Nenhuma opção encontrada para essa busca.'
    }
  },
  data: () => {
    return {
      field: null
    }
  },
  watch: {
    field: function (newVal) {
      this.$emit('update:field', newVal)
    }
  }
}
</script>

<style lang="scss">
  .combo-container {
    display: flex;
    align-items: center;

    .combo-box {
      width: 8em;

      .dropdown-menu {
        text-transform: lowercase;
        font-size: 14px;
        font-family: Roboto, sans-serif;
        font-style: normal;

        li a {
          color: #303030;
        }

        .highlight,
        .highlight a,
        li:hover {
          background: #7f1a54 !important;
          color: #fff;
        }
      }

      .vs__selected,
      .form-control {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 16px;
        text-transform: lowercase;
      }

      .form-control {
        padding: 0px 10px;
      }

      .selected-tag {
        padding: 2px 5px;
        color: #7a7a7a;
      }
    }

    .v-select.disabled .dropdown-toggle,
    .v-select.disabled .dropdown-toggle .clear,
    .v-select.disabled .dropdown-toggle input,
    .v-select.disabled .open-indicator,
    .v-select.disabled .selected-tag.close {
      background: none !important;
    }
  }
</style>
